<app-dialog
  [headerLabel]="'LABEL.SHIPPING_INFO' | translate"
  [primaryActionText]="'ACTION.SAVE' | translate"
  [secondaryActionText]="'ACTION.CANCEL' | translate"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="saveAction"
  [secondaryActionTapped]="cancelAction"
  (onPrimaryAction)="onSave()"
>
  <div id="shipping-info-dialog">
    <app-form-master *ngIf="form" [form]="form" (submitForm)="onSave()">
      <div class="form-row">
        <div class="field-wrapper">
          <app-currency-field
            [label]="'LABEL.AMOUNT' | translate"
            fieldId="shipping_amount_field"
            [currencyCode]="currencyCode"
            [locale]="locale"
            [formControl]="form.get(formKeys.AMOUNT)"
          >
          </app-currency-field>
        </div>
      </div>

      <div class="form-row">
        <div class="field-wrapper">
          <app-date-picker-field
            [label]="'LABEL.SHIP_DATE' | translate"
            fieldId="shipping_date_field"
            [placeholder]="'PLACEHOLDER.ENTER_SHIPPING_DATE' | translate"
            [options]="shippingDateOptions"
            [formControl]="form.get(formKeys.SHIP_DATE)"
          >
          </app-date-picker-field>
        </div>
      </div>

      <div class="form-row">
        <div class="field-wrapper">
          <app-input-field
            [label]="'LABEL.SHIP_VIA' | translate"
            fieldId="shipping_via_field"
            [placeholder]="'PLACEHOLDER.ENTER_SHIPPING_METHOD' | translate"
            [fieldControl]="form.get(formKeys.SHIP_VIA)"
          >
          </app-input-field>
        </div>
      </div>

      <div class="form-row">
        <div class="field-wrapper">
          <app-input-field
            [label]="'LABEL.TRACKING_NUMBER' | translate"
            fieldId="shipping_tracking_number_field"
            [placeholder]="'PLACEHOLDER.ENTER_TRACKING_NUMBER' | translate"
            [fieldControl]="form.get(formKeys.TRACKING_NUMBER)"
          >
          </app-input-field>
        </div>
      </div>

      <div class="form-row">
        <div class="field-wrapper">
          <app-input-field
            [label]="'LABEL.FOB' | translate"
            fieldId="shipping_fob_field"
            [placeholder]="'PLACEHOLDER.ENTER_FREE_SHIPPING_METHOD' | translate"
            [fieldControl]="form.get(formKeys.FOB)"
          >
          </app-input-field>
        </div>
      </div>
    </app-form-master>
  </div>
</app-dialog>
